window.GeoCountryCache = (function () {
  const CACHE_KEY = "geoCountry_global";
  const CACHE_TIME_KEY = "geoCountry_global_time";
  const TTL = 7 * 24 * 60 * 60 * 1000;

  function isBot() {
    const ua = navigator.userAgent.toLowerCase();
    return /(bot|crawl|slurp|spider|mediapartners|facebookexternalhit|pinterest|crawler|bingpreview|ahrefs|yandex|baiduspider)/.test(
      ua,
    );
  }

  function getCached() {
    const country = localStorage.getItem(CACHE_KEY);
    const time = localStorage.getItem(CACHE_TIME_KEY);
    if (!country || !time) return null;

    if (Date.now() - Number(time) > TTL) return null;

    return country;
  }

  function setCached(country) {
    localStorage.setItem(CACHE_KEY, country);
    localStorage.setItem(CACHE_TIME_KEY, Date.now());
  }

  // NOTE:
  // always resolve callback with a value (country code or null)
  // to avoid leaving callers waiting in early-exit scenarios
  function getCountry(callback) {
    const resolve = (value) => {
      if (typeof callback === "function") {
        callback(value ?? null);
      }
    };

    if (typeof Storage === "undefined") {
      resolve(null);
      return;
    }

    if (isBot()) {
      resolve(null);
      return;
    }

    const cached = getCached();
    if (cached) {
      resolve(cached);
      return;
    }

    if (typeof geoip2 === "undefined") {
      resolve(null);
      return;
    }

    geoip2.country(
      function (location) {
        const country = location?.country?.iso_code;
        if (!country) {
          resolve(null);
          return;
        }

        setCached(country);
        resolve(country);
      },
      function (error) {
        if (
          typeof console !== "undefined" &&
          typeof console.error === "function"
        ) {
          console.error("GeoIP lookup failed:", error);
        }
        resolve(null);
      },
    );
  }

  return { getCountry };
})();
